module.exports = __webpack_public_path__ + "img/review-csa.e1bc1551.png";